var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1937_7414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.818 37.8963C45.1229 33.9112 47.1167 28.7996 47.1368 23.2226C47.1829 10.5068 36.7153 -0.000281244 23.9994 5.64615e-09C11.2771 0.000281256 0.953244 10.269 0.863619 22.9703C0.773994 35.6717 11.0569 46.1424 23.758 46.2728C25.8665 46.2944 27.9103 46.033 29.8548 45.5255C30.9519 45.2391 32.1156 45.3881 33.0966 45.957C34.4753 46.7566 36.0594 47.4517 37.6508 47.9122C39.326 48.3969 40.8516 46.7934 40.32 45.1327C39.8965 43.8097 39.9921 42.4842 40.2254 41.2409C40.4568 40.0075 41.0169 38.8622 41.818 37.8963Z",
    fill: "#DBE1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.438 32.4249V17.7879C27.438 16.5362 26.1588 15.6918 25.0079 16.1837C23.7332 16.7286 22.3718 17.0427 20.9872 17.1114L18.7041 17.2246C18.1704 17.2512 17.7512 17.6916 17.7512 18.226V19.6541C17.7512 20.2078 18.2001 20.6567 18.7538 20.6567H20.7571C21.216 20.6567 21.588 21.0287 21.588 21.4876V32.4248H19.5371C18.5508 32.4248 17.7512 33.2244 17.7512 34.2106V34.9378C17.7512 35.9241 18.5507 36.7236 19.5371 36.7236H29.4891C30.4753 36.7236 31.2749 35.924 31.2749 34.9378V34.2106C31.2749 33.2244 30.4753 32.4248 29.4891 32.4248L27.438 32.4249Z",
    fill: "#7F9AE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5126 12.7753C26.1281 12.7753 27.4376 11.4657 27.4376 9.85029C27.4376 8.23486 26.1281 6.92529 24.5126 6.92529C22.8972 6.92529 21.5876 8.23486 21.5876 9.85029C21.5876 11.4657 22.8972 12.7753 24.5126 12.7753Z",
    fill: "#7F9AE6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1937_7414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.b1f53e470b48f7a6a536fdfef568f9be.svg";
export { ForwardRef as ReactComponent };